import { render, staticRenderFns } from "./UnderlyingsSection.vue?vue&type=template&id=e9705e60&scoped=true"
import script from "./UnderlyingsSection.vue?vue&type=script&lang=js"
export * from "./UnderlyingsSection.vue?vue&type=script&lang=js"
import style0 from "./UnderlyingsSection.vue?vue&type=style&index=0&id=e9705e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9705e60",
  null
  
)

export default component.exports